import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'

import VideoModal from './Components/VideoModal'

class TutorialWidget extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal() {
    this.setState({ modalIsOpen: true })
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  render() {
    return (
      <Fragment>
        <div className="tutorial-widget" onClick={this.openModal}>
          <Icon type={['fab', 'youtube']} className="tutorial-widget__icon" />
          <span className="tutorial-widget__text">
            {this.props.text}
          </span>
        </div>

        {this.state.modalIsOpen && (
          <VideoModal
            modalIsOpen={this.state.modalIsOpen}
            closeModal={this.closeModal}
            videoId={this.props.videoId}
          />
        )}
      </Fragment>
    )
  }
}

TutorialWidget.propTypes = {
  videoId: PropTypes.string.isRequired,
  text: PropTypes.string,
}

TutorialWidget.defaultProps = {
  text: 'Tutorial',
}

export default TutorialWidget
